export default __webpack_public_path__ + "static/media/save-field-24.ad3aae43.svg";